var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"map"}}),_c('div',{staticClass:"btns"},[_c('button',{staticClass:"draw",on:{"click":function($event){return _vm.draw()}}},[_vm._v("绘制")]),_c('button',{staticClass:"disDraw",on:{"click":function($event){return _vm.disDraw()}}},[_vm._v("关闭绘制")])]),_c('p',{staticClass:"btn",on:{"click":_vm.save}},[_vm._v("保存")])])
}
var staticRenderFns = []

export { render, staticRenderFns }